import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/MainFirst.module.scss'

import { Container, Image, Modal } from 'react-bootstrap'

import SimleForm from './SimleFormV2'
import GreenButton from './GreenButton'

class MainFirst extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      show_video_modal: false
    }
  }

  openVideoModal = () => {
    this.setState({ 
      show_video_modal: true
    });
  }

  closeVideoModal = () => {
    this.setState({ 
      show_video_modal: false
    });
  }

  extractVideoId(url) {
    if (!url) return null;
    
    // Проверяем Rutube
    const rutubeRegExp1 = /rutube\.ru\/video\/([a-zA-Z0-9]+)/;
    const rutubeRegExp2 = /rutube\.ru\/play\/embed\/([a-zA-Z0-9]+)/;
    
    const rutubeMatch1 = url.match(rutubeRegExp1);
    const rutubeMatch2 = url.match(rutubeRegExp2);
    
    if (rutubeMatch1 && rutubeMatch1[1]) return { type: 'rutube', id: rutubeMatch1[1] };
    if (rutubeMatch2 && rutubeMatch2[1]) return { type: 'rutube', id: rutubeMatch2[1] };
    
    // Проверяем YouTube (обычные видео)
    const youtubeRegExp1 = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeRegExp2 = /youtube\.com\/embed\/([^"&?\/\s]{11})/;
    
    const youtubeMatch1 = url.match(youtubeRegExp1);
    const youtubeMatch2 = url.match(youtubeRegExp2);
    
    if (youtubeMatch1 && youtubeMatch1[1]) return { type: 'youtube', id: youtubeMatch1[1] };
    if (youtubeMatch2 && youtubeMatch2[1]) return { type: 'youtube', id: youtubeMatch2[1] };
    
    // Проверяем YouTube Shorts
    const shortsRegExp = /youtube\.com\/shorts\/([^"&?\/\s]{11})/;
    const shortsMatch = url.match(shortsRegExp);
    
    if (shortsMatch && shortsMatch[1]) return { type: 'youtube', id: shortsMatch[1] };
    
    return null;
  }

  getEmbedUrl(videoInfo) {
    if (!videoInfo) return null;
    
    if (videoInfo.type === 'rutube') {
      return `https://rutube.ru/play/embed/${videoInfo.id}/`;
    } else if (videoInfo.type === 'youtube') {
      return `https://www.youtube.com/embed/${videoInfo.id}`;
    }
    
    return null;
  }

  render() {

    const { assets_path, data, className, video } = this.props
    const { show_video_modal } = this.state;

    const videoInfo = data?.video ? this.extractVideoId(data.video) : null;
    const embedUrl = videoInfo ? this.getEmbedUrl(videoInfo) : '';

    return (
      <section className={`${styles.section} ${styles[className]} ${video && styles.svideo}`}>
        {data?.bg != `` &&
          <>
            <Image className={styles.section_bg} src={data?.bg} alt={data?.text_1} />
            <Image className={styles.section_bg_mob} src={data?.bg_mob} alt={data?.text_1 + ` моб.`} />
          </>
        }
        <Container className={styles.section_content}>
          <div className={styles.section_content_best}>{data?.text_1}</div>
          <h1 className={styles.section_content_h1} dangerouslySetInnerHTML={{__html: data?.text_2}} />
          <div className={styles.section_content_podpis}>{data?.text_3}</div>
          <div className={styles.section_content_text} dangerouslySetInnerHTML={{__html: data?.text_4}} />
          <div className={styles.section_content_buttom}>
            <SimleForm
              btn={data?.btntext}
              name={data?.name == `1`}
              assets_path={assets_path}
            />
            {video ?
              <div className={styles.section_content_video_block}>
                {/* Заменяем ссылку на div с обработчиком клика */}
                <div 
                  className={styles.video}
                  onClick={this.openVideoModal}
                  role="button"
                  tabIndex={0}
                  onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal()}
                >
                  <div className={styles.video_content}>
                    <GreenButton
                      text={`Смотреть видео`}
                      width={145}
                    />
                  </div>
                  <Image className={styles.video_poster} src={data?.poster} alt={`Смотреть видео`} width={285} height={130} />
                </div>
                <div className={styles.section_content_video_block_tblock}>
                  <div className={styles.section_content_video_block_tblock_title}>Производство, в котором рождается <span>качество</span></div>
                  <div className={styles.section_content_video_block_tblock_sep} />
                  <div className={styles.section_content_video_block_tblock_text}>Посмотрите, где создают прочные и красивые окна для вашего дома.</div>
                </div>
              </div>
              :
              <div className={styles.section_content_advantages}>
                {data?.list.map( ( elm, k ) => (
                  <>
                    {k > 0 &&
                      <div className={styles.section_content_advantages_sep}></div>
                    }
                    <div className={styles.section_content_advantages_item}>
                      <Image src={elm.icon} width={20} height={20} alt={elm.name} />
                      <div>
                        <div className={styles.section_content_advantages_item_title}>{elm.name}</div>
                        <div className={styles.section_content_advantages_item_text}>{elm.text}</div>
                      </div>
                    </div>
                  </>
                ) )}
              </div>
            }
          </div>
        </Container>

        {/* Модальное окно для видео */}
        <Modal 
          show={show_video_modal} 
          onHide={this.closeVideoModal}
          size="lg"
          centered
          className={styles.video_modal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Производство, в котором рождается качество</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            {embedUrl ? (
              <div className={styles.video_container}>
                <iframe
                  src={embedUrl}
                  width="100%"
                  height="405"
                  frameBorder="0"
                  style={{ border: 'none' }}
                  allow="clipboard-write; autoplay"
                  webkitAllowFullScreen
                  mozallowfullscreen
                  allowFullScreen
                  title="Видео о производстве окон"
                />
              </div>
            ) : (
              <p>Неверная ссылка на видео</p>
            )}
          </Modal.Body>
        </Modal>
      </section>
    )
  }
}

MainFirst.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string,
  className: PropTypes.string,
  video: PropTypes.bool
}

MainFirst.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets',
  className: 'def',
  video: false
}

export default MainFirst